
export const keys = {
    all: ["notification-lists"],

    referenceData: (groupID: number, 
        organizationID: number

    ) => [
        ...keys.all,
        "referencedata", {
            groupID,
            organizationID         
            }
    ],
    notificationList: (
        groupID: number,
        organizationID: number,
        notificationListID: number
        ) => [
            ...keys.all,
            "notificationlist", {
                groupID,
                organizationID,
                notificationListID
            }
        ],
    notificationLists: (
        groupID: number,
        organizationID: number,
        ) => [
            ...keys.all,
            "list", {
                groupID,
                organizationID
            }
        ],
    notificationListUsage: (
        groupID: number,
        organizationID: number,
        notificationListID: number
        ) => [
            ...keys.all,
            "usage", {
                groupID,
                organizationID,
                notificationListID
            }
        ],
                            
};

